export const FEATURE_FLAGS: string[] = [
  "liveBiddingMvp",
  "liveBiddingMvpPlus",
  "closedSalesRedirect",
];
